import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11c9b3b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["placeholder"]
const _hoisted_2 = {
  key: 1,
  class: "name"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "row" }

import { CharacterCard } from "@/components"
	import { computed } from "vue"
	import { formatDistanceToNow } from "date-fns"
	import { useUserDataStore } from "@/stores"

	
export default /*#__PURE__*/_defineComponent({
  __name: 'PartyRow',
  props: {
    clickable: { type: Boolean },
    editableName: { type: Boolean },
    hoverRemove: { type: Boolean },
    index: {}
  },
  emits: ["cardClick"],
  setup(__props: any, { emit: __emit }) {

	const emit = __emit
	const props = __props

	const store = useUserDataStore()
	const meta = computed(() => store.parties[props.index])
	const namePlaceholder = computed(() => `Party ${1 + props.index}`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ cursor: _ctx.clickable ? 'pointer' : 'default' }),
    class: "wrapper"
  }, [
    (_ctx.editableName)
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          placeholder: namePlaceholder.value,
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).parties[props.index].name) = $event))
        }, null, 8, _hoisted_1)), [
          [_vModelText, _unref(store).parties[props.index].name]
        ])
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(meta.value?.name || namePlaceholder.value) + " ", 1),
          (meta.value.updatedAt)
            ? (_openBlock(), _createElementBlock("time", _hoisted_3, "(" + _toDisplayString(_unref(formatDistanceToNow)(meta.value.updatedAt, { addSuffix: true })) + ")", 1))
            : _createCommentVNode("", true)
        ])),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3], (pos) => {
        return _createVNode(_unref(CharacterCard), {
          characterId: meta.value.members[pos],
          clickable: _ctx.hoverRemove ? Boolean(meta.value.members[pos]) : true,
          hoverIntention: _ctx.hoverRemove && meta.value.members[pos] ? 'remove' : 'pick',
          key: pos,
          onClick: ($event: any) => (emit('cardClick', pos))
        }, null, 8, ["characterId", "clickable", "hoverIntention", "onClick"])
      }), 64))
    ])
  ], 4))
}
}

})